import { connect } from 'react-redux'
import { withProps, withHandlers, compose } from 'recompose'
import { withLicencePlate } from 'src/components/VehicleConfigurator'
import { updateVehicle } from '../../../actions'
import { VEHICLE_EDITOR_LICENCE_FORM } from '../../../constants'
import LicenceEditor from './LicenceEditor'

const withCustomSubmit = compose(
  connect(null, { updateVehicle }),
  withHandlers({
    handleSubmit: ({ getVehicleByPlateNumber, updateVehicle }) => data =>
      getVehicleByPlateNumber(data, null, updateVehicle)
  })
)

const withFormName = withProps({ formName: VEHICLE_EDITOR_LICENCE_FORM })

export default compose(
  withLicencePlate,
  withCustomSubmit,
  withFormName
)(LicenceEditor)
